<template>
  <div>
    
    <memlist-card
      class="mb-2 edit-template-container"
      ref="edit-template"
      id="edit-template"
    >
      <form class="" @submit.prevent="save_template">

        <m-row>
          <m-col lg="2">
            <memlist-text-input
              class="mt-4"
              id="input-template_id"
              v-model="local_value.template_id"
              type="text"
              required
              disabled
              title="ID"
              layout="vertical"
              size="sm"
              validation_type="TEXT"
            />
          </m-col>
          <m-col lg="4">
            <memlist-text-input
              class="mt-4"
              id="input-group-1"
              v-model="local_value.name"
              :title="$t('TEMPLATE.NAME')"
              layout="vertical"
              size="sm"
              required
              validation_type="TEXT"
              :state="valid_name_state"
            />
          </m-col>
          <m-col lg="4">
            <memlist-checkbox
              class="mt-12"
              v-model="local_value.is_system"
              :text="$t('TEMPLATE.SYSTEM')"
            />
          </m-col>
        </m-row>

        <m-row>
          <m-col lg="6">
            <memlist-text-input
              class="mt-4"
              id="from_id-group"
              :title="$t('PAGES.SENDOUT.FROM_ID')"
              v-model="local_value.from_id"
              :placeholder="$t('PAGES.SENDOUT.FROM_ID')"
              :state="validFromId"
            />
            <p style="font-style: italic; color: #888888;">{{ $t('TEMPLATE.FROM_ID_INFO') }}</p>

          </m-col>
          <m-col lg="4">

            <memlist-checkbox
              v-if="false"
              class="mt-4"
              v-model="local_value.is_theme"
              :text="$t('TEMPLATE.IS_THEME')"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4">
          <m-col lg="4">
            <memlist-search-select 
              v-model="merge_tag"
              :items="merge_tags_options"
              :title="$t('TEMPLATE.MERGE_TAGS')"
              layout="vertical"
              @input="merge_tag_selected"
            />

          </m-col>
          <m-col lg="4">
            <memlist-code-box class="mt-8" :code="merge_tag" v-if="merge_tag" />
          </m-col>
        </m-row>

        <m-row class="mt-4">
          <m-col lg="8">
            <div class="flex-col-left">
              <memlist-textarea
                ref="sms-textarea"
                class="mt-4"
                layout="vertical"
                :title="$t('TEMPLATE.SMS_MESSAGE')"
                v-model="local_value.text"
                :placeholder="$t('TEMPLATE.SMS_MESSAGE')"
                rows="3"
                max-rows="6"
              />
            </div>
            
          </m-col>

          <m-col lg="4">
            <div class="button-align-bottom">
              <memlist-icon-button
                class="mb-2 mt-12"
                svg="/assets/svg/sms.svg"
                :text="$t('TEMPLATE.SEND_TEST_SMS')"
                variant="primary"
                @click="send_test_sms"
              />
            </div>
          </m-col>
        </m-row>


        

        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-checkbox
              v-model="shorten_urls"
              :text="$t('TEMPLATE.SHORTEN_URLS')"
            />
            <p style="font-style: italic; color: #888888;">{{ $t('TEMPLATE.SHORTEN_URLS_INFO') }}</p>
          </m-col>
          <m-col lg="2" style="display: flex; align-items: top;">
            <span>Antal SMS: </span><div class="ml-2 num-sms">{{ num_sms }}</div>
          </m-col>

        </m-row>

        <m-row class="mt-4" v-if="!has_unreg_link">
          <m-col lg="8">
            <p><b style="color: red;">Avregistreringslänk saknas:</b> Vill du infoga avregistreringslänken? Klicka på knappen nedan.</p>
            <memlist-button @click="insert_unreg_link" variant="warning">Infoga avregistreringslänk</memlist-button>
          </m-col>
          <m-col lg="4">
            
          </m-col>
        </m-row>
        
        
        
        <div class="mt-4">
                    
          <memlist-button v-if="source === 'sendout'" variant="success" class="ml-2" @click="backToSendout"
            >{{$t('SENDOUT.CONTINUE_TO_SENDOUT')}}</memlist-button>
        </div>

        <m-row>
          <m-col lg="12">
            <RightModalSaveAndCloseButtons
              :text="$t('COMMON.SAVE')"
              :spin="true"
              @clicked="submit_form"
              @close="on_cancel"
              ref="saveButton"
            />
          </m-col>
        </m-row>

      </form>
      
    </memlist-card>

    <memlist-modal ref="send-test-sms-modal">
      <m-row>
        <m-col lg="12">
          <p>Testdata kommer att genereras för att fylla ut merge-tags.</p>
        </m-col>
      </m-row>
      <m-row class="mt-4">
        <m-col lg="6">
          <memlist-text-input 
            :title="$t('MEMBER.PHONE')"
            v-model="test_sms_number"
          />
          <p class="mt-2" style="font-style: italic; color: #888888;">Mobiltelefon att skicka till. Kostnad tillkommer.</p>
        </m-col>
      </m-row>
      <m-row>
        <m-col lg="12">
          <memlist-button @click="send_sms" variant="primary">{{ $t('COMMON.SEND') }}</memlist-button>
        </m-col>
      </m-row>
    </memlist-modal>

  </div>
</template>

<script>


import axios from 'axios';
import { mapGetters } from 'vuex';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import { upload_file } from '@/core/services/fileUpload';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import __tags from '@/assets/plugins/email-editor/merge-tags.js';


export default {
  name: 'TemplateSMSEdit',
  mixins: [ toasts ],
  components: {
    RightModalSaveAndCloseButtons,
  },
  props: {
    source: {
      type: String,
      default: null,
    },
    sendout_id: {
      type: Number,
      default: null,
    },
    item: {
      type: Object,
    }
  },
  emits: ['updated', 'created', 'cancel'],
  computed: {
    num_sms() {
      return Math.max(1, Math.ceil((this.local_value.text+'').length / 140));
    },
    has_unreg_link() {
      return (this.local_value?.text || '').indexOf('%SMS_UNREG_LINK%') >= 0;
    },
    has_merge_tags_inside() {
      return (this.local_value?.text || '').indexOf('%') >= 0;
    },
    merge_tags_options() {
      return __tags.map(item => ({ text: item.name, value: `%${item.id}%` }));
    },

    sendout_template_type_options() {

      const base = [
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_DONATION_RECEIVED'), value: 'DONATION_NEW_DONATION_RECEIVED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_SINGLE'), value: 'DONATION_THANK_YOU_SINGLE' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_RECURRING'), value: 'DONATION_THANK_YOU_RECURRING' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SIMPLE_FORM_ANSWERED'), value: 'SIMPLE_FORM_ANSWERED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT'), value: 'TICKET_EVENT' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT_ADMIN_NOTIFICATION'), value: 'TICKET_EVENT_ADMIN_NOTIFICATION' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TODO_UPDATED'), value: 'TODO_UPDATED' },
      ];
      

      if (this.isTHS) {
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SAMFUND_MEMBERS_ERROR_REPORT'), value: 'SAMFUND_MEMBERS_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GENERAL_ERROR_REPORT'), value: 'GENERAL_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_CUSTOMER'), value: 'DONATION_NEW_CUSTOMER' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_WELCOME_ADMIN'), value: 'DONATION_WELCOME_ADMIN' });
      }

      if (this.global_settings.type === 'kvitto') {
        
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.EMAIL_NOT_MATCHED'), value: 'EMAIL_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED_AND_FORWARDED'), value: 'KVITTO_RECEIVED_AND_FORWARDED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_ERROR'), value: 'KVITTO_ERROR' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NO_RULE_MATCHED'), value: 'KVITTO_NO_RULE_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED'), value: 'KVITTO_RECEIVED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_MATCHED'), value: 'KVITTO_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NOT_MATCHED'), value: 'KVITTO_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ACCOUNT_TRANSACTION_NEED_MATCH'), value: 'ACCOUNT_TRANSACTION_NEED_MATCH' });
      }

      if (this.global_settings.type === 'support') {

        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INFO_MAIL'), value: 'SALES_INFO_MAIL' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INVITE_MEETING'), value: 'SALES_INVITE_MEETING' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_FOLLOW_UP'), value: 'SALES_FOLLOW_UP' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_SIGN_CONTRACT'), value: 'SALES_SIGN_CONTRACT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_WELCOME_AFTER_SIGN'), value: 'SALES_WELCOME_AFTER_SIGN' });
      }

      return base;
    },

    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'user', 'isTHS', 'unlocks', 'customer', 'global_settings']),

    validFromId() {
      return this.validate_from_id();
    },

    creating() {
      return isNaN(parseInt(this.local_value.template_id+''));
    },
    valid_name_state() {
      if (!this.local_value.name) { return false; }
      if (this.local_value.name.length > 0) { return true; }
      return false;
    }
  },
  mounted() {
    if (this.value) {
      this.local_value = { ...this.value };
    }
  },
  data() {
    return {
      test_sms_number: null,
      shorten_urls: false,
      merge_tag: null,
      attachments: [],
      active_tab: 0,
      sendout_template_type: null,
      local_value: {},
      isValid: true,

      moving: false,
      templates: [],
      fullscreen: false,
    };
  },

  watch: {
    async shorten_urls() {
      if (this.shorten_urls && this.local_value.text) {
        const urls = this.parse_out_urls_in_text(this.local_value.text);

        for (const url of urls) {
          if (url.indexOf('/x/') >= 0) {
            continue;
          }

          if (url.length < 30) {
            continue;
          }
          
          const link = await this.post_short_link(url);

          this.local_value.text = this.local_value.text.replace(url, link.shorturl);

        }

        this.local_value = { ...this.local_value };
      }
    },
    item: {
      deep: true,
      handler(new_value, old_value) {
        if (this.item) {
          this.local_value = { ...this.item }
        }

        this.local_value.is_sms = true;

        this.test_sms_number = this.user.phone;
      },
      immediate: true
    },

    'local_value.text': {
      deep: true,
      handler(new_value, old_value) {
        this.local_value.num_sms = Math.max(1, Math.ceil((new_value+'').length / 140));
        
      }
    },

    'local_value.from_id'() {
      this.validate_from_id();
    },

  },
  methods: {
    merge_tag_selected(tag) {
      const textarea = this.$refs['sms-textarea']?.$el?.querySelector('textarea');
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = this.local_value.text || '';

      // Insert tag at cursor position
      const before = text.substring(0, start);
      const after = text.substring(end);

      const newText = before + tag + after;
      this.local_value.text = newText;

      // Move cursor after inserted tag
      this.$nextTick(() => {
        textarea.focus();
        const newPos = start + tag.length;
        textarea.setSelectionRange(newPos, newPos);
      });

      // Clear selected tag
      this.merge_tag = null;
    },

    insert_unreg_link() {
      this.local_value.text += '\n%SMS_UNREG_LINK%';
    },
    async post_short_link(url) {
      try {
        const res = await axios.post(`/link/exists`, { href: url });

        if (res.status === 201) {
          return res.data;
        }
      }
      catch (err) {
        console.error('post_short_link error', err);
      }

      throw 'unable to create';
    },

    parse_out_urls_in_text(text) {
      if (!text || typeof text !== 'string') return [];

      const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/gi;
      const matches = text.match(urlRegex);
      return matches || [];
    },

    async handle_file_upload() {
      const file = this.$refs.file.files[0];

      if (file.size > (50000000)) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.MUST_BE_LESS'));
        return;
      }

      try {
        const newfile = await upload_file(file, { file_type: 'PUBLIC_IMAGE', is_public: true });

        const res = await axios.post(`/template/${this.local_value.template_id}/attachment`, { file_id: newfile.file_id });

        if (res.status === 201) {
          this.attachments.push(res.data);
        }
        
        this.toastr('success', this.$t('COMMON.OK'), this.$t('FILE.UPLOADED'));
      }
      catch (err) {
        console.error('handle_file_upload', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FILE.UNABLE_UPLOAD'));
      }
      
    },

    select_file() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },

    async update_file(index, file_id) {
      /*this.local_form.images[index].file_id = file_id;
      this.emit_update();*/
    },

    async remove_file(index) {
      const attachment = this.attachments[index];
      const res = await axios.delete(`/template/attachment/${attachment.id}`);
      
      if (res.status === 204) {
        this.attachments.splice(index, 1);
      }
    },

    on_cancel() {
      this.$emit('cancel');
    },

    async submit_form() {

      this.save_template();

      this.$refs['saveButton'].stop();
    },

    async on_create_to_instance_clicked() {

      this.$refs['select-instances-modal'].show();
    },

    validate_from_id() {
      if (!this.local_value.is_sms) {
        return false;
      }

      if (this.local_value.from_id === null || this.local_value.from_id === undefined || this.local_value.from_id.length === 0) {
        this.isValid = false;
        return false;
      }

      if (this.local_value.from_id.length > 11) {
        this.isValid = false;
        return false;
      }

      const re = /[^a-z\d]/i;

      const test = !re.test(String(this.local_value.from_id).toLowerCase());
      this.isValid = test;
      return test;
    },
    update_editor() {
      if (this.$refs['emailTemplateEditor']) {
        this.$nextTick(() => {

          if (this.$refs['emailTemplateEditor']) {
            this.$refs['emailTemplateEditor'].force_reload();
          }

        });
      }
    },

    copyTemplateToCompany(template_id, company_id) {
      const loader = this.$loading.show();

      axios
        .post(`/template/copy`, { template_id: template_id, company_id: company_id })
        .then(res => {
          loader && loader.hide();
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
        });
    },

    copyTemplate(template, movable = false) {
      const loader = this.$loading.show();

      if (!movable || template.company_id == this.currentCompanyId) {
        axios
          .post(`/template/copy`, { template_id: template.template_id })
          .then(res => {
            loader && loader.hide();

            this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
          });
      } else {
        axios
          .get(`/template/${template.template_id}`)
          .then(res => {
            loader && loader.hide();
            this.local_value = res.data;
            this.attachments = res.data.attachments;
            this.moving = true;

            this.local_value.edit_html = this.local_value.edit_html ? JSON.parse(this.local_value.edit_html) : null;
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
          });
      }
    },
    deleteTemplateClicked(template_id) {
      this.toDelete = template_id;
      this.$refs['deleteTemplateConfirm'].show();
    },
    onDeleteTemplateConfirm() {
      this.deleteTemplate(this.toDelete);
      this.toDelete = null;
    },

    deleteTemplate(template_id) {
      const loader = this.$loading.show();

      axios
        .delete(`/template/${template_id}`)
        .then(res => {
          loader && loader.hide();

          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.DELETED'));
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_DELETE'));
        });
    },
    changeSystem(template) {
      const loader = this.$loading.show();
      axios
        .put(`/template/${template.template_id}`, template)
        .then(res => {
          loader && loader.hide();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.UPDATED'));
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
        });
    },

    async save_template() {
      const loader = this.$loading.show();
      this.local_value.company_id = this.currentCompanyId;

      this.local_value.num_sms = this.local_value.num_sms ? parseInt(this.local_value.num_sms+'') : 1;
      this.local_value.type = 'SMS';

      if (this.creating) {

        axios
          .post('/template', this.local_value)
          .then(res => {
            loader && loader.hide();
            if (res.status === 201) {
              this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.CREATED'));
              this.local_value.template_id = res.data.template_id;
              this.$emit('created', this.local_value);
            }
            else {
              this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_CREATE'));
            }
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_CREATE'));
          });
      } else if (!this.creating) {

        axios
          .put(`/template/${this.local_value.template_id}`, this.local_value)
          .then(res => {
            loader && loader.hide();
            if (res.status === 204) {
              this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.UPDATED'));
              this.$emit('updated', this.local_value);
            }
            else if (res.status === 409) {

              swal.fire({
                title: this.$t('COMMON.ERROR'),
                icon: 'error',
                html: this.$t('TEMPLATE.INVALID_EMAILS'),
                showCloseButton: false,
                showCancelButton: false,
                focusConfirm: false,
              });

            }
            else {
              this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
            }
          })
          .catch(err => {
            loader && loader.hide();
            console.error(err);
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
          });
      }

      if (this.isTHS && this.sendout_template_type) {
        axios.post(`/template/sendout`, { customer_id: this.customer.id, type: this.sendout_template_type, template_id: this.local_value.template_id });
      }

    },
    

    backToSendout() {
      this.$router.push(`/ml-sendout/${this.sendout_id}`);
    },
    setTemplateProps() {
      const sendout_id = parseInt(this.$route.params.sendout_id);
      const id = this.$route.params.template_id;
      const editing = Boolean(parseInt(this.$route.params.is_edit));

      if (!isNaN(sendout_id)) {
        this.local_value.template_id = editing ? id : '';
        this.sendout_id = sendout_id;
      }
    },
    moveToCompanies() {
      const company_ids = this.$refs['companies_selected'].getCompanies();

      for (const cid of company_ids) {
        this.copyTemplateToCompany(this.local_value.template_id, cid);
      }

      this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
    },
    send_test_sms() {
      this.$refs['send-test-sms-modal'].show();
    },
    async send_sms() {

      const res = await axios.post(`/sms/template/${this.local_value.template_id}/test`, {
        phone: this.test_sms_number
      });

      if (res.status === 201) {
        this.toastr('success', this.$t('COMMON.OK'), this.$t('SMS.SMS_SENT'));
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SMS.UNABLE_SEND'));
      }

      this.$refs['send-test-sms-modal'].hide();
    },
  }
};
</script>

<style lang="scss" scoped>


.modal-xl {
  max-width: 100% !important;
  padding-right: 17px;
}

:deep .dark-modal {
  color: white;
  background-color: #293039;
  border-bottom: 1px solid #444c56;
}

:deep .dark-modal-body {
  color: white;
  background-color: #293039;
}

.ml-url-link:hover {
  cursor: pointer;
}
.custom-grid-row {
  display: flex;
  gap: 1rem;
  width: 100%;
  align-items: stretch;
  margin-top: 1.5rem; // like mt-4

  .left-col {
    flex: 2;
    display: flex;
    flex-direction: column;
  }

  .right-col {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .button-align-bottom {
    margin-top: auto;
  }
}

.num-sms {
  background-color: #dedede;
  color: black;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  text-align: center;
}
</style>

